import { getBlogRow } from "./getBlogRow";
export function createArticleList(allBlogs)
{
    const blogs = allBlogs ? allBlogs : window.g2Data.response.docs;
    const blogWrapper = $('.blog-section');
    blogs.forEach(function (e: any, i: any)
    {
        const row = getBlogRow(e, i);
        blogWrapper.append(row);
    });
}
